import defaultSocket from 'Src/network/socket';
import * as provisioner from 'Src/vendor/posapi/provisioner';
import { AutomatedCoreService as ProvisionerCoreService } from 'Src/vendor/posapi/provisioner.svc';

const coreService = new ProvisionerCoreService(defaultSocket);

type LocationOption = provisioner.definitions['types.LocationOptionViewModelWithTerminals'];
type OrganizationOption = provisioner.definitions['types.OrganizationOptionViewModel'];

type AuthResponseBroken = provisioner.definitions['auth.SystemUserAuthNResponse'];
interface AuthResponse extends Omit<AuthResponseBroken, 'bridgeUser'> {
  bridgeUser: AuthResponseBroken['bridgeUser'] & { username: string; }
}
type TerminalOption = provisioner.definitions['provisionable.TerminalOptionViewModel'];
type TerminalAndLocation = provisioner.definitions['terminal.terminalViewModel'];
// the provision service auto-generated types is separate from the pos
// - this is because this subset is shared between bridge and pos

const service = {
  location: {
    getAll: coreService['PROVISIONER:GET:Locations.WithTerminals'],
  },
  organization: {
    getAll: coreService['PROVISIONER:GET:Organizations'],
  },
  login: async (...args: Parameters<typeof coreService['PROVISIONER:Login']>) => {
    // pluck out the username during login as this type does not appear to come back from the server
    const [{ username }] = args;
    const response = await coreService['PROVISIONER:Login'](...args);
    response.bridgeUser = Object.assign(response.bridgeUser, { username });
    return response as unknown as AuthResponse;
  },
  terminal: {
    provisionTerminal: coreService['PROVISIONER:POST:Terminal.ProvisionToken'],
    getTerminal: coreService['PROVISIONER:GET:Terminal'],
    killProvisionClaim: coreService['PROVISIONER:DELETE:Terminal.ProvisionToken'],
  }
};

export default service;
export type { AuthResponse, LocationOption, OrganizationOption, TerminalAndLocation, TerminalOption };
